import * as React from 'react';

interface SectionProps {
  title?: string;
  subtitle?: string;
  children?: React.ReactNode;
  className?: string;
}

export default function Section({ title, subtitle, children, className }: SectionProps) {
  return (
    <section className={"mb-20 " + (className || '')}>
      {(title || subtitle) && (
        <header className="mb-8 space-y-2 text-center max-w-2xl mx-auto">
          {title && <h1 className="text-3xl font-semibold tracking-tight">{title}</h1>}
          {subtitle && <p className="text-sm text-[var(--brand-muted)]">{subtitle}</p>}
        </header>
      )}
      {children}
    </section>
  );
}
